<template>
  <div class="block-form">
    <div class="form-field">
      <div class="form-label">Variante</div>
      <q-btn-toggle
        :model-value="block.variant"
        :options="variantOptions"
        unelevated
        dense
        no-caps
        toggle-color="primary"
        @update:model-value="emit('update', { ...block, variant: $event })"
      />
    </div>
    <q-input
      outlined
      :model-value="block.title"
      label="Título (opcional)"
      @update:model-value="emit('update', { ...block, title: String($event ?? '') })"
    />
    <q-input
      outlined
      type="textarea"
      :model-value="block.text"
      label="Texto"
      rows="3"
      @update:model-value="emit('update', { ...block, text: String($event ?? '') })"
    />
  </div>
</template>

<script setup lang="ts">
interface CalloutBlock {
  type: 'callout';
  variant: 'info' | 'warning' | 'tip' | 'example' | 'key';
  title?: string;
  text?: string;
}

const props = defineProps<{ block: CalloutBlock }>();
const emit = defineEmits<{ (e: 'update', block: CalloutBlock): void }>();

const variantOptions = [
  { label: 'Info', value: 'info' },
  { label: 'Atención', value: 'warning' },
  { label: 'Consejo', value: 'tip' },
  { label: 'Ejemplo', value: 'example' },
  { label: 'Clave', value: 'key' },
];

void props;
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.form-label {
  font-size: 13px;
  color: var(--oa-text-muted);
  margin-bottom: 6px;
}
</style>
